import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoService } from './base-dto.service';
import { BaseEstimateStatusClient, BaseEstimateStatusDto } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class BaseEstimateStatusService extends BaseDtoService {
    constructor(private readonly client: BaseEstimateStatusClient) {
        super();
    }

    async getAll(): Promise<BaseEstimateStatusDto[]> {
        return await lastValueFrom(this.client.baseEstimateStatusGetAll());
    }

    async getById(id: number): Promise<BaseEstimateStatusDto> {
        return await lastValueFrom(this.client.baseEstimateStatusGetById(id));
    }

    async getByIds(ids: number[]): Promise<BaseEstimateStatusDto[]> {
        return await lastValueFrom(this.client.baseEstimateStatusGetByIds(ids));
    }
}
